import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { PrimeNGConfig } from "primeng/api";
import {
  LocalStorageService,
  RouterExtService,
  SignalrService,
} from "./_services";
import { AppConstant } from "./shared/webdatarocks/app.constant";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  horizontalMenu: boolean;

  darkMode = false;

  menuColorMode = "light";

  menuColor = "layout-menu-light";

  themeColor = "blue";

  layoutColor = "blue";

  ripple = true;

  inputStyle = "outlined";

  constructor(
    private _router: Router,
    private primengConfig: PrimeNGConfig,
    private _signalrService: SignalrService,
    private routerExtService: RouterExtService
  ) {}

  ngOnInit() {
    this.primengConfig.ripple = true;
    const token = sessionStorage.getItem(AppConstant.LoginToken);
    if (!token) {
      LocalStorageService.removeAllStorageValue();
      this._router.createUrlTree(["/login"]);
    }

    // Restore the previous route if it exists
    const savedUrl = localStorage.getItem("currentUrl");
    if (savedUrl && savedUrl !== "/auth/login") {
      // Navigate to the saved URL after the page reload
      this._router.navigateByUrl(savedUrl, { skipLocationChange: true });
    }

    // this.encryptionService.initialize();
    this._signalrService.startConnection();
  }

  ngAfterContentInit(): void {
    // If the current URL is still /login, redirect to root with skipLocationChange
    if (
      this.routerExtService
        .getCurrentUrl()
        .includes("/report/report-generate/:id") ||
      this.routerExtService.getCurrentUrl().includes("/login")
    ) {
      this.routerExtService.router.navigateByUrl("/", {
        skipLocationChange: true,
      });
    }
  }

  @HostListener("window:beforeunload", ["$event"])
  unloadHandler(event: Event): void {
    const current = this.routerExtService.getCurrentUrl();
    localStorage.setItem("current", current);
  }
}
